import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { CirclePlus, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";
import { IItemHistoricoPlano } from "../../../../types";

const detectaNovoPrecoAdicionado = (acao: string, origem_evento?: string): boolean => {
  const acaoLower = acao.toLowerCase().trim();
  return (acaoLower === 'novo serviço adicionado' || acaoLower.includes('novo serviço adicionado') || acaoLower === 'novo preço adicionado' || acaoLower.includes('novo preço adicionado')) 
    && origem_evento === 'TEMPLATE_GLOBAL';
};

const getIconNovoPrecoAdicionado = (acao: string, origem_evento?: string): { Icon: LucideIcon; color: string } => {
  return { Icon: CirclePlus, color: 'var(--c2e86de)' };
};

export default function CardNovoPrecoAdicionado({ item, isExpanded, onToggleExpand }: CardHistoricoProps) {
  const itemPlano = item as IItemHistoricoPlano;
  const titulo = itemPlano.origem_evento === 'TEMPLATE_GLOBAL' 
    ? 'Novo serviço adicionado (Template)' 
    : 'Novo serviço adicionado';

  return (
    <CardHistoricoBase
      item={item}
      icon={getIconNovoPrecoAdicionado(item.acao, itemPlano.origem_evento)}
      temExpansaoDisponivel={true}
      isExpanded={isExpanded}
      onToggleExpand={onToggleExpand}
      expandedContent={<ExpandedContent item={item} />}
      tituloCustomizado={titulo}
    />
  );
}

export const novoPrecoAdicionadoConfig = {
  tipo: 'novo_preco_adicionado',
  detectaTipo: detectaNovoPrecoAdicionado,
  getIcon: getIconNovoPrecoAdicionado,
  temExpansao: () => true,
  Component: CardNovoPrecoAdicionado
};
